var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { InstrumentLookupComparer } from '@shared/utils/Instruments/InstrumentLookupComparer';
import { InstrumentSpecificType } from '@shared/utils/Instruments/InstrumentSpecificType';
import { InstrumentUtils } from '@shared/utils/Instruments/InstrumentUtils';
import { DataCache } from '../../DataCache';
import { TerceraSymbolLookupBaseDataProvider } from '../../NoNFixedListCore';
import { TvSymbolConvertor } from '../Convertors/TvSymbolConvertor';
import { TvExchangesManger } from './TvExchangesManger';
import { TvInstrumentTypesManager } from './TvInstrumentTypesManager';
export class TvSearchSymbolManager {
    constructor() {
        this.dataProvider = new TerceraSymbolLookupBaseDataProvider();
    }
    searchSymbols(userInput, exchange, symbolType) {
        return __awaiter(this, void 0, void 0, function* () {
            let filteredInstrumentList = [];
            const findStr = !isNullOrUndefined(userInput) ? userInput.toLowerCase() : '';
            const exchanges = !isNullOrUndefined(exchange) && exchange !== TvExchangesManger.AllExchanges ? [exchange] : null;
            const instrumentTypes = !isNullOrUndefined(symbolType) && symbolType !== TvInstrumentTypesManager.AllTypes && symbolType !== ''
                ? TvSymbolConvertor.getInstrumentTypes(symbolType)
                : null;
            if (DataCache.NonFixedList) {
                filteredInstrumentList = yield this.getFilteredNonFixedList(findStr, exchanges, instrumentTypes);
            }
            else {
                filteredInstrumentList = yield this.getFilteredFixedList(findStr, exchanges, instrumentTypes);
            }
            const compareParams = { pattern: findStr, isSortByInstrumentType: true };
            const sortedInstrumentList = InstrumentLookupComparer.sortInstrumentList(filteredInstrumentList, compareParams);
            sortedInstrumentList.sort((i1, i2) => Number(i2.haveContiniousContract) - Number(i1.haveContiniousContract));
            return sortedInstrumentList;
        });
    }
    getFilteredNonFixedList(filter, exchanges, instrumentTypes) {
        return __awaiter(this, void 0, void 0, function* () {
            const nonFixedList = yield this.dataProvider.getInstrumentsList(filter, exchanges, instrumentTypes, true, false);
            return nonFixedList;
        });
    }
    getFilteredFixedList(filter, exchanges, instrumentTypes) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, reject) => {
                const defaultInstruments = DataCache.Instruments;
                const filteredInstrumentList = [];
                const filterExchange = exchanges !== null && exchanges.length > 0 ? exchanges[0] : null;
                for (const insK in defaultInstruments) {
                    const ins = defaultInstruments[insK];
                    if (!ins) {
                        continue;
                    }
                    if (filterExchange !== null && filterExchange !== ins.TradingExchange) {
                        continue;
                    }
                    if (instrumentTypes !== null && !instrumentTypes.includes(ins.InstrType)) {
                        continue;
                    }
                    if (ins.InstrumentSpecificType === InstrumentSpecificType.ContinuousContract) {
                        continue;
                    }
                    let curItemFindStr = ins.DisplayName();
                    const descr = ins.DescriptionValue();
                    curItemFindStr = (curItemFindStr + (!isNullOrUndefined(descr) ? ' (' + descr + ')' : '')).toLowerCase();
                    if (!curItemFindStr.toLowerCase().includes(filter)) {
                        continue;
                    }
                    filteredInstrumentList.push(ins);
                }
                resolve(filteredInstrumentList);
            });
        });
    }
    getSymbolByName(nameWithExchange) {
        if (!nameWithExchange) {
            return null;
        }
        const devidedParts = InstrumentUtils.DivideFullName(nameWithExchange);
        const name = devidedParts.name;
        const exchange = devidedParts.route;
        // кейс, когда видно несколько роутов
        // здесь непонятно как разруливать, поэтому просто берем первый инструмент
        // Нам инструмент заходит в виде EUR/AUD:LMAX,
        // После разделителя это не роут а биржа, в том виде, в котором он отображается в лукапе TV чарта
        const defaultInstruments = DataCache.Instruments;
        for (const insK in defaultInstruments) {
            const ins = defaultInstruments[insK];
            if (!ins) {
                continue;
            }
            if (exchange) {
                const tradingExchage = ins.TradingExchange;
                if (exchange !== tradingExchage) {
                    continue;
                }
            }
            if (ins.DisplayName() === name) {
                return ins;
            }
        }
        return null;
    }
    dispose() {
        this.dataProvider.dispose();
    }
}
